import script from "./StepDay.vue?vue&type=script&setup=true&lang=js"
export * from "./StepDay.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import DateGrid from "@/components/neue/wizard/DateGrid.vue";
import HighlightedText from "@/components/neue/wizard/HighlightedText.js";
import WeekdayPicker from "@/components/neue/wizard/WeekdayPicker.vue";
import WizardIcon from "@/components/neue/wizard/WizardIcon.vue";
import WizardSection from "@/components/neue/wizard/WizardSection.vue";
script.components = Object.assign({}, { DateGrid, HighlightedText, WeekdayPicker, WizardIcon, WizardSection }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { DateGrid, HighlightedText, WeekdayPicker, WizardIcon, WizardSection }, script.__o.components);}